<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Payment-Policy-List",
  path: "list",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
